import React from 'react';
import InfoTooltip from '@ui/tooltip/InfoTooltip';
import type PricingRoom from '@app/model/pricing-automation/PricingRoom';
import { pricingRoomName } from '@app/site/secured/rateshopper/pricing-automation/architecture/component/PricingRoomName.utilities';

type PricingRoomNameRoom = Pick<PricingRoom, 'roomName' | 'rateType' | 'integrationId' | 'rateName' | 'board'> & { catalogueEligible?: boolean };

const valueOrDash = (value: string | number | null | undefined): string | number =>
	value === null || value === undefined || value === '' ? '—' : value;

// One line of the panel: a long value (a rate plan name) wraps under the value, not under the label.
const RatePlanLine: React.FunctionComponent<{ label: string, value: string | number }> = ({ label, value }) =>
	<span className="flex gap-x-1">
		<span className="shrink-0">{label}:</span>
		<span className="min-w-0 font-medium text-gray-900">{value}</span>
	</span>;

// Provisional historical plans remain visible, but cannot be selected for pricing.
const PricingRoomName: React.FunctionComponent<{ room: PricingRoomNameRoom }> = ({ room }) => {
	const hasRateType = room.rateType !== null && room.rateType !== undefined && room.rateType !== '';

	return <>
		{room.catalogueEligible === false && <span className="mr-1 text-xs text-amber-700">Refresh required ·</span>}
		{room.roomName}{hasRateType && <span className="text-xs font-normal text-gray-500"> ({room.rateType})</span>}
		{hasRateType && <span className="ml-1 inline-flex align-middle font-normal"
			// The PMS Inventory row opens the assign window on a click; a click on the icon must not.
			onClick={event => event.stopPropagation()}>
			<InfoTooltip label={`Rate plan details of ${pricingRoomName(room)}`} title="PMS Rate Plan">
				<RatePlanLine label="Rate plan" value={valueOrDash(room.rateName)} />
				<RatePlanLine label="Rate plan id" value={valueOrDash(room.integrationId)} />
				<RatePlanLine label="Board id" value={valueOrDash(room.board)} />
			</InfoTooltip>
		</span>}
	</>;
};

export default PricingRoomName;
